var map = {
	"./404.svg": 21342,
	"./Action-Plan.svg": 31516,
	"./academy.svg": 79096,
	"./acao-atrasada.svg": 85854,
	"./analysis.svg": 42164,
	"./badge.svg": 50695,
	"./bug.svg": 35844,
	"./calendar-check.svg": 59867,
	"./calendar-month.svg": 99737,
	"./caret-right-bold.svg": 1302,
	"./chart.svg": 64166,
	"./check-list.svg": 8455,
	"./clipboard.svg": 1600,
	"./closed-padlock.svg": 26903,
	"./company.svg": 295,
	"./component.svg": 19711,
	"./config.svg": 45904,
	"./dashboard.svg": 68770,
	"./documentation.svg": 82752,
	"./dollar.svg": 30516,
	"./double-check.svg": 28350,
	"./drag.svg": 8208,
	"./drop-down.svg": 32070,
	"./drop-up.svg": 28477,
	"./edit.svg": 84742,
	"./education.svg": 30852,
	"./email.svg": 20030,
	"./example.svg": 53656,
	"./excel.svg": 55139,
	"./excel2.svg": 16155,
	"./exchange.svg": 49525,
	"./exit-fullscreen.svg": 86228,
	"./eye-open.svg": 64418,
	"./eye.svg": 20349,
	"./file-export.svg": 64335,
	"./file-medical.svg": 62730,
	"./form.svg": 11968,
	"./fullscreen.svg": 50961,
	"./gerenciar-usuarios.svg": 37318,
	"./graph-up.svg": 85644,
	"./guide.svg": 87418,
	"./health.svg": 66756,
	"./icon.svg": 67841,
	"./id-card.svg": 50536,
	"./international.svg": 4998,
	"./language.svg": 4660,
	"./link.svg": 8938,
	"./list.svg": 97790,
	"./lock.svg": 2555,
	"./locked.svg": 57400,
	"./message.svg": 25615,
	"./money.svg": 11026,
	"./nested.svg": 37379,
	"./open-padlock.svg": 63467,
	"./password.svg": 13865,
	"./pdf.svg": 47212,
	"./pdf2.svg": 16854,
	"./people.svg": 60255,
	"./peoples.svg": 41758,
	"./person-add.svg": 66035,
	"./person-badge.svg": 68035,
	"./qq.svg": 9084,
	"./registration.svg": 30253,
	"./save.svg": 60209,
	"./search.svg": 50194,
	"./select-selector.svg": 14248,
	"./shopping.svg": 9934,
	"./signal.svg": 90170,
	"./size.svg": 2213,
	"./skill.svg": 98461,
	"./star.svg": 15138,
	"./stopwatch.svg": 2455,
	"./tab.svg": 45439,
	"./table.svg": 3974,
	"./theme.svg": 86621,
	"./three-vertical-dots.svg": 25566,
	"./tree-table.svg": 64797,
	"./tree.svg": 48566,
	"./unlike.svg": 73474,
	"./unlocked.svg": 5185,
	"./user-cog.svg": 89825,
	"./user.svg": 95587,
	"./wechat.svg": 70108,
	"./zip.svg": 52383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;